import { FunctionComponent, useCallback, useMemo } from 'react';
import { CalendarEvent } from '..';
import React from 'react';
import styles from './styles.module.scss';
import { DateRange } from '../../../services/DateRange';
import { useDateFormatter } from '../../../hooks';

export type EventComponentProps<T> = {
    event: CalendarEvent<T>;
    timezone: string;
    locale: string;
    spansMultipleDays: boolean;
};

export const DefaultEventComponent: FunctionComponent<EventComponentProps<any>> = ({
    event,
    spansMultipleDays,
}) => {
    const formatTinyDate = useDateFormatter({ day: '2-digit', month: 'short' });
    const formatTime = useDateFormatter({ timeStyle: 'short' });

    const getTimeRange = useCallback(
        (range: DateRange): string => {
            return `${formatTime(range.from)} → ${formatTime(range.to)}`;
        },
        [formatTime]
    );

    const getMultiDayTimeRange = useCallback(
        (range: DateRange): string => {
            return `${formatTime(range.from)} → ${formatTinyDate(range.to)} @ ${formatTime(range.to)}`;
        },
        [formatTime, formatTinyDate]
    );

    const timeLabel = useMemo(() => {
        return spansMultipleDays ? getMultiDayTimeRange(event.range) : getTimeRange(event.range);
    }, [event, spansMultipleDays, getTimeRange, getMultiDayTimeRange]);

    return (
        <div className={styles.event}>
            <time dateTime={event.range.from.toISOString()}>{timeLabel}</time>
            {event.label}
        </div>
    );
};
